module.exports = __webpack_public_path__ + "img/ss-c.ceb52780.svg";